export default "/images/vendor/flag-icon-css/flags/4x3/uy.svg?4c3f85c5401c3a3875eedbcd2173f43f";